import { v4, validate } from "uuid";

export const uuid = (): string => v4();
export const uuidValid = (value: string): boolean => validate(value);
